import { render, staticRenderFns } from "./RegistCertificate.vue?vue&type=template&id=e2df249c&scoped=true"
import script from "./RegistCertificate.vue?vue&type=script&lang=js"
export * from "./RegistCertificate.vue?vue&type=script&lang=js"
import style0 from "./RegistCertificate.vue?vue&type=style&index=0&id=e2df249c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2df249c",
  null
  
)

export default component.exports